import React from 'react';
import {
  Heading1, Heading3, LinkStyled, Paragraph,
} from '../components/typography';
import { Row, Col, Container } from '../components/grid';
import { Image } from '../components/Image';
import SidemenuLayout from '../layout/DefaultLayout/Layouts/SidemenuLayout';

export default () => (
  <SidemenuLayout menuPicker="OmOs" activeSidemenu="Historie">
    <Container white>
      <Row>
        <Col xs={12}>
          <Heading1>Historien om PETER SKAFTE ApS</Heading1>
        </Col>
      </Row>
      <Row>
        <Col xs={12} sm={9}>
          <Paragraph>
            Handels-, distributions- og servicevirksomhed
          </Paragraph>
          <Paragraph>
            Etableret 1983 - omdannet til anpartsselskab 1990.
          </Paragraph>
          <Paragraph>
            Anpartskapital fuldt indbetalt: Kr. 1.015.000,-
          </Paragraph>
          <Paragraph>
            Eneejer, direktør og leder: ølhandler Peter Skafte, født 1965
          </Paragraph>
          <Paragraph>
            Formål:<br />
            Udbringning af drikkevarer til klubber, kantiner,<br />
            kontorer, arbejdspladser, messer, receptioner etc.<br />
            <br />
          </Paragraph>
          <Paragraph>
            Speciale i udlejning af tappeanlæg og fadøl til<br />
            fester i virksomheder, selskabslokaler og privat.<br />
            <br />
          </Paragraph>
          <Paragraph>
            Import og eksport af drikkevarer.
          </Paragraph>
          <Paragraph>
            Distriktsforhandler for Carlsberg’s: ”Fadølsforsyningen”
          </Paragraph>
          <Paragraph>
            Domicil:
            Disponerer i overdækket anlæg over lejede lokaler fordelt på 3 storhaller på tilsammen 1.000 m2 lagerplads indrettet med pallereoler samt 65 m2 kontorfaciliteter.
            <br /><br />
          </Paragraph>
          <Heading3>Historien bag Peter Skafte Øl &amp; Vand</Heading3>
          <Paragraph>
            <br />
            Peter lagde ud med een lille lastbil.
            Startkapitalen kom fra den avisrute, han drev,
            de sidste par år af sin skoletid.
            Kontor og lager var derhjemme,
            og hans mor passede telefonen.
            Senere måtte der lejede lokaler til og flere biler og folk.
            Over årene har forretningen udviklet sig til nu 10 ansatte,
            der dækker hele Storkøbenhavn med 6 distributionsbiler.
            Peter Skafte Øl &amp; Vand blev grundlagt med en lille
            eenmandsbetjent lastbil i sommeren 1983,
            da Peter var 19 år gammel og lige havde afsluttet
            det matematiske gymnasium.
          </Paragraph>
          <Paragraph>
            Pengene til at starte for kom fra den avisudbringning,
            Peter drev gennem de sidste år af sin skoletid.
            Langt derude på midtsjælland,
            hvor de boede, var der ingen søndagsaviser.
            Det så Peter som en indtjeningsmulighed.
            Men Bladkompagniet afviste kategorisk at oprette en avisrute.
            Så måtte Peter i en alder af 15 år etablere sig som
            selvstændig avishandler med indbetaling af depositum,
            forpligtelse til afregning for de modtagne aviser og
            eget ansvar for, om der indgik betalinger fra kunderne.
            Heldigvis var der dog masser af betalende kunder,
            der satte stor pris på den kontinuitet og præcision,
            hvormed de hver eneste søndag morgen modtog deres avis.
          </Paragraph>
          <Paragraph>
            Peters forældre havde et lille landsted,
            der hurtigt blev omdannet til varelager og
            forretningsdomicil med moderen som telefonpasser
            ved hjemmets spisebord og faderen som regnskabsfører.
            Computeren var dog opfundet og i den første sommerferie
            udviklede og programmerede Peter sit eget lager- og faktureringssystem,
            der den dag i dag er rygraden i al styring af virksomhedens aktiviteter.
            Fra den allerførste dag knæsatte Peter det princip aldrig at sige
            nej til en bestilling og aldrig at svigte en aftalt levering.
            I dag er han selv ikke et øjeblik i tvivl om, at denne fundering på
            villighed og pålidelighed er baggrunden for hans succes
            igennem nu snart 30 år. I årenes løb har Peter, med skiftende held,
            forsøgt at konsolidere og sikre forretningens eksistens ved at
            sprede investeringerne til andre brancher og aktiviteter.
            Han har været importør af Legoklodser i Rusland med 10 mand
            ansat både i Moskva og Sankt Pedersborg.
            Han har handlet med brugte Rolex-ure.
            Det har dog vist sig, at handelen med øl og vand har
            været det mest stabile,
            hvorfor alle kræfter nu er koncentreret om dette ene formål.
          </Paragraph>
          <Paragraph>
            Under den store ølstrejke i 1985 var Peter primus motor
            i fremskaffelsen af udenlandsk øl, navnlig fra Belgien,
            og i 6-7 hektiske uger var alle disponible kammerater
            og familiemedlemmer engageret i døgndrift med at servicere
            tørstende kunder overalt på hele sjælland.
            Takket være rigtig mange pålidelige,
            loyale og dygtige, serviceindstillede medarbejdere
            gennem årene, er virksomheden i dag en moderne,
            toptrimmet distributionsforretning for servicering af
            alle mulige firmaer, foreninger, arbejdspladser, kontorer,
            kantiner, receptioner, messer og selskabslokaler i alle
            størrelser og brancher - enten i faste rutiner eller ved
            eengangsleverancer. Det er ikke på nogen måde overdrevet,
            når Peter med stolthed slår fast, at han i tidens løb har
            leveret til praktisk talt alle større og kendte virksomheder
            og arrangementer i København lige fra Kongehuset over
            ministerierne til Bakken, Kanonhallerne, Bella Center, DSB,
            Parken og mange officielle fester etc.
            Adskillige konfirmationer, bryllupper, jubilæer og andre
            mærkedage er også i årenes løb blevet fejret succesfuldt
            med fadøl fra Peter Skafte Øl &amp; Vand.
          </Paragraph>
          <Paragraph>
            Virksomheden har 10 ansatte og kører med i alt
            6 distributionsvogne.
            Fra 2008 tages en helt ny type miljøskånende lastvogn i brug,
            der drives frem af elektromotorer og til stor fryd og lettelse
            for personalet sænker ladet helt ned i gadeniveau,
            når der skal læsses af og på.
            Denne nyanskaffelse er karakteristisk for Peters
            ledelsesfilosofi, hvor han lige fra starten, år efter år,
            har investeret i arbejdsbesparende og medarbejdervenlige
            hjælpemidler, som fx. først letvægts- og siden elektriske
            trappesækkevogne, der blev indført helt tilbage i 1990erne.
          </Paragraph>
          <Paragraph>
            I 1990 blev Peters enkeltmandsfirma omdannet til
            PETER SKAFTE ANPARTSSELSKAB med Peter som eneejer
            og direktør. Han foretrækker dog fortsat at betegne sig
            selv som ølhandler.
            Og det til trods for, at mere end 80 procent af salget
            i vore dage ligger på sodavand, kildevand og de populære
            frugtsafte.
            I 2008 kan Peter fejre 30 års jubilæum som selvstændig
            forretningsdrivende og glæde sig over at have udviklet
            en veltrimmet og velfungerende servicevirksomhed i fortsat
            fremgang.
            Recepten er uforandret:
            Alle kunder betjenes, så snart de henvender sig,
            firmaet siger aldrig NEJ og de bestilte varer leveres
            i det rette kvantum på aftalt tid og sted.
          </Paragraph>
          <Paragraph>
            Firmaet opretholder et omfattende og effektivt
            kontrolsystem, der fuldstændigt sikrer kunderne,
            at enhver misforståelse eller uoverensstemmelse straks
            kan lokaliseres og rettes uden tab eller ulempe for kunden.
            Firmaet har en fast, men yderst rimelig betalingspolitik,
            der går ud på, at varerne i princippet skal betales kontant
            ved modtagelsen - men under brug af vore dages elektroniske
            systemer, accepteres betalingen overført indenfor 14 dage
            fra leveringen.
            I de senere år har Peter knyttet en del udenlandske kontakter,
            og i dag er der en omfattende både im- og eksport af kendte og
            anerkendte drikkevaremærker, så som Hof, Ramløsa, Coca-Cola og
            kildevand. I november 2007 begyndte han udviklingen af en
            fuldelektrisk lastbil, kaldet <LinkStyled to="/bandit">bandit</LinkStyled>.
            Lastbilen havde to kæmpe fordele.
            1: hele ladet kunne sættes direkte på jorden.
            2: Bilen var 100% miljøvenlig.
            Peter løb desværre ind i en række forhindringer og projektet
            endte med at blive lukket ned.
          </Paragraph>
          <Paragraph>
            I 2012 overtog Peter Skafte aftalen om Sodavandsautomater
            fra det konkursramte Logida,
            som havde fået aftalen fra Carlsberg.
            Idag står han derfor for drift, opsætning og levering
            af alle disse sodavandsautomater.
            En af de store fordele for vores kunder er,
            at de ikke skal betale andet end prisen for de vand,
            der sættes i automaterne.
          </Paragraph>
        </Col>
        <Col xs={12} sm={3} textCenter>
          <Image name="historie.historie-bagende-lastbil-formervangen.jpg" alt="Peter skafte lager hos Dansk Rust formervangen glostrup" />
          <Paragraph textCenter>
            Lager Formervangen Glostrup
          </Paragraph>
          <Image name="historie.historie-hiace-lille-trailer-tuborg.jpg" alt="Blå Toyota Hiace, tomgods pladsen hos Tuborg Brøndby" />
          <Paragraph textCenter>
            Tuborg Depotet i Brøndby
          </Paragraph>
          <Image name="historie.historie-tomme-fustager-efter-fest.jpg" alt="Tomme fustager efter fest" />
          <Paragraph textCenter>
            Tomme fustager efter studenterfest
          </Paragraph>
          <Image name="historie.historie-finn-ved-ford-gargo-og-gaffeltruck.jpg" alt="Finn ved Frod cargo ølvogn og gaffeltruk" />
          <Paragraph textCenter>
            Meget lav Ford Gargo ølbil
          </Paragraph>
          <Image name="historie.historie-jan-maj-hk.jpg" alt="1. maj fest" />
          <Paragraph textCenter>
            Retur efter 1.maj fest i HK København
          </Paragraph>
          <Image name="historie.historie-thomas-vasker-udstyr-naverland.jpg" alt="Thomas vasker udstyr" />
          <Paragraph textCenter>
            Thomas vasker fadølstappeanlæg
          </Paragraph>
          <Image name="historie.historie-fors-lastbil.jpg" alt="Lastbil" />
          <Paragraph textCenter>
            Tidligere distributions ølbil fra 80&quot;erne
          </Paragraph>
          <Image name="historie.historie-lager-naverland-tomgods.jpg" alt="Lager Naverland" />
          <Paragraph textCenter>
            Lagerhal Naverland i Glostrup
          </Paragraph>
          <Image name="historie.historie-lastbil-og-hiace-albertslund.jpg" alt="Lastbil og Hiace i Albertslund" />
          <Paragraph textCenter>
            Hiace og Ford ølbil med rullegardiner
          </Paragraph>
          <Image name="historie.historie-pizza-pronto.jpg" alt="Pizza Pronto" />
          <Paragraph textCenter>
            Firmaets faste pizzeria i mange år
          </Paragraph>
          <Image name="historie.historie-rense-stestrup.jpg" alt="Rens" />
          <Paragraph textCenter>
            Rensning af tappeanlæg i Stestrup
          </Paragraph>
          <Image name="historie.historie-lager-formervangen-lastbil-gaffeltruck.jpg" alt="Lager Formervanger m. lastbil og gaffeltruck" />
          <Paragraph textCenter>
            Første lagerhal Formervangen i Glostrup
          </Paragraph>
          <Image name="historie.historie-nyt-udstyr-stestrup.jpg" alt="Nyt udstyr" />
          <Paragraph textCenter>
            10 nye køleanlæg importeret fra England
          </Paragraph>
          <Image name="historie.historie-hiace-stestrup.jpg" alt="Hiace i Stestrup" />
          <Paragraph textCenter>
            Hiace på gården i Stestrup
          </Paragraph>
          <Image name="historie.historie-kontor-stestrup.jpg" alt="Første kontor i Stestrup" />
          <Paragraph textCenter>
            Første kontor i Stestrup
          </Paragraph>
          <Image name="historie.historie-lager-fuldgods-naverland.jpg" alt="Lager fuld gods i Naverland" />
          <Paragraph textCenter>
            Anden lagerhal Naverland i Glostrup
          </Paragraph>
          <Image name="historie.historie-carlsberg-tomgods-ringsted.jpg" alt="Carlsberg Ringsted" />
          <Paragraph textCenter>
            Carlsberg tomgods i Ringsted
          </Paragraph>
          <Image name="historie.historie-hiace-trailer-foran-naverland.jpg" alt="Hiace med trailer" />
          <Paragraph textCenter>
            Vogntog foran lager på Naverland
          </Paragraph>
          <Image name="historie.bandit-front.jpg" alt="Bandit lastbil" />
          <Paragraph textCenter>
            Bandit lastbil
          </Paragraph>
          <Image name="historie.coca-cola-automat-lille.jpg" alt="Sodavandsautomat" />
          <Paragraph textCenter>
            Coca Cola automat
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
